import { render, staticRenderFns } from "./Travelers.vue?vue&type=template&id=58c21369&scoped=true&"
import script from "./Travelers.vue?vue&type=script&lang=js&"
export * from "./Travelers.vue?vue&type=script&lang=js&"
import style0 from "./Travelers.vue?vue&type=style&index=0&id=58c21369&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c21369",
  null
  
)

export default component.exports